/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CompanyDetailsViewModel } from './CompanyDetailsViewModel';
import {
    CompanyDetailsViewModelFromJSON,
    CompanyDetailsViewModelFromJSONTyped,
    CompanyDetailsViewModelToJSON,
} from './CompanyDetailsViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfCompanyDetailsViewModel
 */
export interface ResultOfCompanyDetailsViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfCompanyDetailsViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfCompanyDetailsViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfCompanyDetailsViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfCompanyDetailsViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfCompanyDetailsViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfCompanyDetailsViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfCompanyDetailsViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {CompanyDetailsViewModel}
     * @memberof ResultOfCompanyDetailsViewModel
     */
    data?: CompanyDetailsViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfCompanyDetailsViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfCompanyDetailsViewModel interface.
 */
export function instanceOfResultOfCompanyDetailsViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfCompanyDetailsViewModelFromJSON(json: any): ResultOfCompanyDetailsViewModel {
    return ResultOfCompanyDetailsViewModelFromJSONTyped(json, false);
}

export function ResultOfCompanyDetailsViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfCompanyDetailsViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : CompanyDetailsViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfCompanyDetailsViewModelToJSON(value?: ResultOfCompanyDetailsViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': CompanyDetailsViewModelToJSON(value.data),
        'Count': value.count,
    };
}

